import { PlayCircleIcon } from '@langchain/untitled-ui-icons';

import { Button, Tooltip } from '@/design-system';

export default function GoToPlaygroundButton({
  onClick,
  error,
  canEdit,
}: {
  onClick?: () => void;
  error?: string;
  canEdit?: boolean;
}) {
  const buttonText = canEdit ? 'Playground' : 'Try it';

  return (
    <Tooltip title={error} disabled={!error}>
      <Button
        size="md"
        color="primary"
        onClick={onClick}
        leftDecorator={PlayCircleIcon}
        disabled={!!error}
        className="whitespace-nowrap"
      >
        {buttonText}
      </Button>
    </Tooltip>
  );
}
